import { createFileRoute } from "@tanstack/react-router";

import { AdminSettingsPage } from "@/components/admin/AdminSettingsPage";

export const Route = createFileRoute("/administrator/settings")({
  head: () => ({ meta: [{ title: "Settings · GENRL Admin" }] }),
  component: AdminSettingsPage,
});
